
import React from 'react';
import { InertiaApp } from '@inertiajs/inertia-react'
import { render } from 'react-dom'

import '../css/custom.scss';
import '../css/image-uploader.min.css';

require('./bootstrap');
require('alpinejs');
const app = document.getElementById('app')

render(
  <InertiaApp
    initialPage={JSON.parse(app.dataset.page)}
    resolveComponent={name => import(`./Pages/${name}`).then(module => module.default)}
  />,
  app
)